import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { VehicleComponent } from './component/vehicle/vehicle.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DraggablemodalComponent } from './component/draggablemodal/draggablemodal.component';
import { Draggablemodal1Component } from './component/draggablemodal1/draggablemodal1.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DiagnosticComponent } from './component/diagnostic/diagnostic.component';
import { FormsModule } from '@angular/forms';
import { SymptomsComponent } from './component/symptoms/symptoms.component';
import { InfoComponent } from './component/info/info.component';
import { ManualDiagnosisComponent } from './component/manual-diagnosis/manual-diagnosis.component';
import { IdentifyFailureComponent } from './component/identify-failure/identify-failure.component';
import { CloseCancelDiagnosisComponent } from './component/close-cancel-diagnosis/close-cancel-diagnosis.component';
import { HotlineComponent } from './component/hotline/hotline.component';
import { AdminComponent } from './component/admin/admin.component';
import { TargettingEngineOverrideComponent } from './component/targetting-engine-override/targetting-engine-override.component';
import { TargettingEngineTestComponent } from './component/targetting-engine-test/targetting-engine-test.component';
import { VariantSummaryComponent } from './component/variant-summary/variant-summary.component';
import { GtacTemplateComponent } from './component/gtac-template/gtac-template.component';
import{ TargettingEngineStatusComponent } from './component/targetting-engine-status/targetting-engine-status.component';
import { ManageRoleQualifierComponent } from './component/manage-role-qualifier/manage-role-qualifier.component';
import { DynamicOdlFormComponent } from './component/dynamic-odl-form/dynamic-odl-form.component';
import { SBDHomeComponent } from './component/sbd-home/sbd-home.component';
import { Draggablemodal3Component } from './component/draggablemodal3/draggablemodal3.component';
import { ManageuserComponent } from './component/manageuser/manageuser.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { DraggablemodalhotlineComponent } from './component/draggablemodalhotline/draggablemodalhotline.component';
import { HotlinefilterPipe } from './pipe/hotlinefilter.pipe'
import { NgxPaginationModule } from 'ngx-pagination';
import { CommonModule, DatePipe } from '@angular/common';
import { AdhocComponent } from './component/adhoc/adhoc.component';
import { WarrantyDealerCodeComponent } from './component/warranty-dealer-code/warranty-dealer-code.component';
import { ManageWarrantyDealerCodeComponent } from './component/manage-warranty-dealer-code/manage-warranty-dealer-code.component';
import { RepairqualificationComponent } from './component/repairqualification/repairqualification.component';
import { StartupComponent } from './component/startup/startup.component';
import { AddRoleComponent } from './component/add-role/add-role.component';
import { VehicleSessionsComponent } from './component/vehicle-sessions/vehicle-sessions.component';
import { HelpVehicleSessionsComponent } from './component/help-vehicle-sessions/help-vehicle-sessions.component';
import { RepairProcedureComponent } from './component/repair-procedure/repair-procedure.component';
import { PostrepairprocedureComponent } from './component/postrepairprocedure/postrepairprocedure.component';
import { MainFdrsComponent } from './component/main-fdrs/main-fdrs.component';
import { SbdrdsmappingComponent } from './component/sbdrdsmapping/sbdrdsmapping.component';
import { OauthcredComponent } from './component/oauthcred/oauthcred.component';
import { FdrsViewComponent } from './component/fdrs-view/fdrs-view.component';
import { DiagnosticFdrsViewComponent } from './component/diagnostic-fdrs-view/diagnostic-fdrs-view.component';
import { NetworkTestComponent } from './component/network-test/network-test.component';
import { OtxCandidateComponent } from './component/otx-candidate/otx-candidate.component';
import { EtisCandidateComponent } from './component/etis-candidate/etis-candidate.component';
import { ErrorCandidateComponent } from './component/error-candidate/error-candidate.component';
import { GlobalManagedServicesComponent } from './component/global-managed-services/global-managed-services.component';
import { ShowRulesComponent } from './component/show-rules/show-rules.component';
import { RecurringRuleComponent } from './component/recurring-rule/recurring-rule.component';
import { OffroadRuleComponent } from './component/offroad-rule/offroad-rule.component';
import { VehicleSessionsViewComponent } from './component/vehicle-sessions-view/vehicle-sessions-view.component';
import { VehicleSessionsLinkComponent } from './component/vehicle-sessions-link/vehicle-sessions-link.component';
import { RepairPostRepairCandidateComponent } from './component/repair-post-repair-candidate/repair-post-repair-candidate.component';
import { ScheduleJobComponent } from './component/schedule-job/schedule-job.component';
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AutomationToolComponent } from './component/automation-tool/automation-tool.component';
import { AdfsProfilesComponent } from './component/adfs-profiles/adfs-profiles.component';
import { AdfsClientsComponent } from './component/adfs-clients/adfs-clients.component';
import { AdfsWebservicesComponent } from './component/adfs-webservices/adfs-webservices.component';
import { NgChartsModule } from 'ng2-charts';
import { GlobalSeriveEnabledComponent } from './component/global-serive-enabled/global-serive-enabled.component';
import { PinpointPipePipe } from './pipe/pinpoint-pipe.pipe';
import { FeaturemappingsComponent } from './component/featuremappings/featuremappings.component';
import { DisplayDiagnosticComponent } from './component/display-diagnostic/display-diagnostic.component';
import { HelpdeskRvcComponent } from './component/helpdesk-rvc/helpdesk-rvc.component';
import { OauthRealmPropertiesComponent } from './component/oauth-realm-properties/oauth-realm-properties.component';
import { ReportAProblemPageComponent } from './component/report-a-problem-page/report-a-problem-page.component';
import { OTXReportComponent } from './component/otx-report/otx-report.component';
import { VehicleHelpComponent } from './component/vehicle-help/vehicle-help.component';
import { DTCDataComponent } from './dtcdata/dtcdata.component';
import { NgxSpinnerService } from "ngx-spinner";
import { NgxSpinnerModule } from "ngx-spinner";
import { ImportDtcListViewComponent } from './component/import-dtc-list-view/import-dtc-list-view.component';
import { ScheduleJobModalPopupComponent } from './component/schedule-job-modal-popup/schedule-job-modal-popup.component';
import { DataCollectorInformationComponent } from './component/data-collector-information/data-collector-information.component';
import { ViewDataCollectorInfoComponent } from './component/view-data-collector-info/view-data-collector-info.component';
import { UnauthorizedAccessViewComponent } from './component/unauthorized-access-view/unauthorized-access-view.component';
import { TokenExpiryNotificationComponent } from './component/token-expiry-notification/token-expiry-notification.component';
import { AddTempDealerCodeComponent } from './component/add-temp-dealer-code/add-temp-dealer-code.component';
import { QuillModule } from 'ngx-quill';
import { ReportsComponent } from './component/reports/reports.component';
import { ReportErrorsComponent } from './component/report-errors/report-errors.component';
import { ReportVinIssueComponent } from './component/report-vin-issue/report-vin-issue.component';
import { ReportReadVinComponent } from './component/report-read-vin/report-read-vin.component';
import { ReportVciIssueComponent } from './component/report-vci-issue/report-vci-issue.component';
import { ReportLostCommunicationComponent } from './component/report-lost-communication/report-lost-communication.component';
import { ReportVinMismatchComponent } from './component/report-vin-mismatch/report-vin-mismatch.component';
import { ReportBrowserComponent } from './component/report-browser/report-browser.component';
import { CheckExistingSessionComponent } from './component/check-existing-session/check-existing-session.component';


@NgModule({
  declarations: [
    AppComponent,
    VehicleComponent,
    DraggablemodalComponent,
    Draggablemodal1Component,
    DiagnosticComponent,
    SymptomsComponent,
    InfoComponent,
    ManualDiagnosisComponent,
    IdentifyFailureComponent,
    CloseCancelDiagnosisComponent,
    HotlineComponent,
    AdminComponent,
    TargettingEngineOverrideComponent,
    TargettingEngineTestComponent,
    VariantSummaryComponent,
    ReportsComponent,
    GtacTemplateComponent,
    TargettingEngineStatusComponent,
    ManageRoleQualifierComponent,
    DynamicOdlFormComponent,
    SBDHomeComponent,
    Draggablemodal3Component,
    ManageuserComponent,
    DraggablemodalhotlineComponent,
    HotlinefilterPipe,
    AdhocComponent,
    WarrantyDealerCodeComponent,
    ManageWarrantyDealerCodeComponent,
    RepairqualificationComponent,
    StartupComponent,
    AddRoleComponent,
    VehicleSessionsComponent,
    HelpVehicleSessionsComponent,
    RepairProcedureComponent,
    PostrepairprocedureComponent,
    MainFdrsComponent,
    SbdrdsmappingComponent,
    OauthcredComponent,
    FdrsViewComponent,
    DiagnosticFdrsViewComponent,
    NetworkTestComponent,
    OtxCandidateComponent,
    EtisCandidateComponent,
    ErrorCandidateComponent,
    GlobalManagedServicesComponent,
    ShowRulesComponent,
    RecurringRuleComponent,
    OffroadRuleComponent,
    VehicleSessionsViewComponent,
    VehicleSessionsLinkComponent,
    RepairPostRepairCandidateComponent,
    ScheduleJobComponent,
    AutomationToolComponent,
    AdfsProfilesComponent,
    AdfsWebservicesComponent,
    GlobalSeriveEnabledComponent,
    AdfsClientsComponent,
    AdfsWebservicesComponent,
    PinpointPipePipe,
    FeaturemappingsComponent,
    DisplayDiagnosticComponent,
    HelpdeskRvcComponent,
    OauthRealmPropertiesComponent,
    ReportAProblemPageComponent,
    OTXReportComponent,
    VehicleHelpComponent,
    DTCDataComponent,
    ImportDtcListViewComponent,
    ScheduleJobModalPopupComponent,
    DataCollectorInformationComponent,
    ViewDataCollectorInfoComponent,
    UnauthorizedAccessViewComponent,
    TokenExpiryNotificationComponent,
    AddTempDealerCodeComponent,
    ReportsComponent,
    ReportErrorsComponent,
    ReportVinIssueComponent,
    ReportReadVinComponent,
    ReportVciIssueComponent,
    ReportLostCommunicationComponent,
    ReportVinMismatchComponent,
    ReportBrowserComponent,
    CheckExistingSessionComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    NgxPaginationModule,
    CommonModule,
    NgChartsModule,
    NgxSpinnerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (httpTranslateLoader),
        deps: [HttpClient],
      },
      isolate: false
    }),
    QuillModule.forRoot()
  ],
  providers: [HttpClient,DatePipe,NgxSpinnerService],
  bootstrap: [AppComponent],schemas:[CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class AppModule { }
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

  declare global {
    interface Navigator {
      msSaveOrOpenBlob?: (blob: any, defaultName?: string) => boolean
      msSaveBlob: (blob: Blob, fileName: string) => boolean
    }

}
